import React, { useEffect, useState } from 'react'
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const GrantDetails1 = () => {

	const App = useApp()
	const [tabList, setTabList] = useState(0)

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="shadow">
				<div className={`${styles["grant-list"]} padding`}>
					<div className="flex-justify_between align_center">
						<div className={styles.category}>지자체 지원금 <i className="tag tag-round tag-red ml_5">100% 적합</i></div>
						<span className={styles.step}>대분류&gt;중분류&gt;소분류</span>
					</div>
					<p className={`${styles.title} mt_10`} style={{ fontSize: "1.8rem" }}>대형 건축물 부설주차장(노외주차장 포함) 방범설비 점검</p>
					<div className={`${styles["tag-group"]} mt_10`}>
						<span>#저소득층</span>
						<span>#다가정자녀</span>
						<span>#중위소득40%</span>
						<span>#시설종사자</span>
					</div>
					<div className={`${styles.price} mt_20`}><strong>5,000</strong> 만원(연4회)</div>
				</div>
			</div>
			<div className="shadow">
				<div className="padding">
					<h3>기관정보</h3>
					<ul className="list-item mt_30">
						<li>
							<span>소관기관</span>
							<span>
								서울특별시 광진구 안전건설교통국<br />
								교통지도과
							</span>
						</li>
						<li>
							<span>문의처</span>
							<span>
								서울특별시 광진구 복지환경국<br />
								청소과
							</span>
						</li>
					</ul>
					<div className="flex-justify_end mt_10">
						<div className={styles["list-btn"]}>고객센터</div>
						<div className={`${styles["list-btn"]} ml_10`}>홈페이지</div>
					</div>
				</div>
			</div>
			<div className="no-scroll pt_30" style={{ overflowX: "auto" }}>
				<ul className="tab-round no-wrap">
					<li onClick={() => setTabList(0)} className={tabList === 0 ? "active" : ""}>기본정보</li>
					<li onClick={() => setTabList(1)} className={tabList === 1 ? "active" : ""}>지원내용</li>
					<li onClick={() => setTabList(2)} className={tabList === 2 ? "active" : ""}>신청방법</li>
				</ul>
			</div>
			<div className="padding pt_20">
				<ul className={styles["explain-list"]}>
					<li>
						<div className={styles.title}>서비스 목적</div>
						<p>FTA 등 시장 개방에 대응하여 버섯 산업 및 특용작물(녹차, 약용작물 등)을 신성장 동력 산업으로 육성하기 위해 버섯 재배사 개․보수 지원 및 특용 작물(약용작물, 녹차 등) 생산, 보관 시설 등 시설 현대화를 통한 품질 고급화 및 생산성 제고, 안정적인 수출기반 조성</p>
					</li>
					<li>
						<div className={styles.title}>지원대상</div>
						<p>강화군에 거주하면서 밭 면적 1,000㎡ 이상으로 신선 농산물을 경작하는 「농어업경영체 육성 및 지원에 관한 법률」제4조에 따라 농업경영정보를 등록한 농업인 또는 생산자단체 등</p>
					</li>
					<li>
						<div className={styles.title}>지원형태</div>
						<div className={styles["tag-area"]}>
							<span>#민원안내</span>
							<span>#교육/용역</span>
							<span>#상담/법률지원</span>
							<span>#시설이용</span>
						</div>
					</li>
					<li>
						<div className={styles.title}>선정기준</div>
						<p>방범설비 설치 건축물</p>
					</li>
					<li>
						<div className={styles.title}>중복불가 서비스</div>
						<p>해당없음</p>
					</li>
					<li>
						<div className={styles.title}>지원내용</div>
						<ul>
							<li>
								<p>프로그램 사용료 할인</p>
								<ul>
									<li>- 국가유공자 및 그 배우자 : 50% 할인</li>
									<li>- 서울특별시 동작구에 거주하는 국민기초생활 보장수급자 : 50% 할인</li>
									<li>- 장애인복지법에 따라 등록된 장애인 및 1~3급 장애인과 동행하는 보호자 1명 : 50% 할인</li>
									<li>- 노인복지법 제26조에 의거 경로우대를 받는지 : 65세 이상 70세 이하 30% 할인 / 71세 이상 50% 할인</li>
									<li>- 다자녀 가정 할인 : 동작구에 거주하는 만18세 이하의 자녀가 3인 이상인 가정의 부모 및 자녀에게 사용료의 30% 할인</li>
								</ul>
							</li>
							<li>
								<p>수영장 사용료 할인</p>
								<ul>
									<li>- 12세 이상 55세 이하 여성 : 수영장 사용료의 5% 할인</li>
								</ul>
							</li>
						</ul>
					</li>
					<li>
						<div className={styles.title}>신청기한</div>
						<p>11/30일까지</p>
					</li>
					<li>
						<div className={styles.title}>신청절차</div>
						<p>읍면동 주민센터 방문 신청</p>
					</li>
					<li>
						<div className={styles.title}>접수기관</div>
						<p>서울특별시 광진구 복지환경국 청소과</p>
					</li>
				</ul>
			</div>
		</div>
	)
}

export default GrantDetails1
